/* @flow */
/* eslint-disable */
import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import withI18n from '../../../utils/withI18n';
import { getLabel } from '../../../utils/i18n';
import FlexBox from '../../FlexBox';

const WrapperBox = styled(FlexBox)`
  width: 100%;
  height: 100vh;
  background: url(${require('./imgs/about-careers.jpg')}) center top;
  background-size: cover;
`;

const Content = styled.div`
  width: 100%;
  height: 100%;
  max-width: 1260px;
  margin: 0 auto;
  text-align: center;
  font-family: ${({ theme }) => theme.fontIBMLight};
`;

const Box = styled(FlexBox)`
  width: 594px;
  height: 100vh;
  color: #fff;
  font-family: ${({ theme }) => theme.fontIBMLight};
  text-align: left;
  align-content: center;
  h4 {
    font-size: 24px;
    font-weight: 500;
    color: rgba(240, 185, 11, 1) !important;
    width: 100%;
    margin: 0;
    padding: 0;
    font-family: ${({ theme }) => theme.fontIBMRegular};
  }
  h3 {
    font-size: 54px;
    font-weight: 300;
    line-height: 70px;
    padding: 26px 0;
    margin: 0;
    font-family: ${({ theme }) => theme.fontIBMLight};
  }
  p {
    padding: 0;
    margin: 0 0 30px 0;
    font-size: 20px;
    line-height: 24px;
    color: rgba(255, 255, 255, 0.6);
  }
  a {
    font-size: 18px;
    font-weight: 500;
    color: rgba(240, 185, 11, 1);
    line-height: 32px;
    text-decoration: none;
    font-family: ${({ theme }) => theme.fontIBMMedium};
  }
`;

type Props = {
  i18n: Object,
  locale: string,
};

const mapStateToProps = ({
  locale,
}) => ({
  locale,
});

export default
@withI18n
@connect(mapStateToProps)
class Life extends React.Component<Props> {
  static defaultProps = {
    i18n: {},
    locale: 'en',
  };

  render() {
    const { i18n, locale } = this.props;
    return (
      <WrapperBox direction="column">
        <Content>
          <Box direction="row" align="center">
            <h4>{getLabel('exchange-life-lifeAtBinance', i18n)}</h4>
            <h3>{getLabel('exchange-life-technologyFuture', i18n)}</h3>
            <p>
              {getLabel(
                `exchange-life-ourPeople`,
                i18n
              )}
            </p>
            <a id="life-a-checkForOpenings" href={`/${locale}/career`} target="_blank" rel="noopener noreferrer nofollow">
              {getLabel('exchange-life-checkForOpenings', i18n)} {'>>'}
            </a>
          </Box>
        </Content>
      </WrapperBox>
    );
  }
}
